export default {
  methods: {
    typeForCategory(categoryType) {
      const emojis = ['☕️', '🛠', '📚', '👼', '🎳', '💡', '📢', '📚', '🤩', '🧪', '🧹', '🔑', '🤝', '🎮', '🧑‍💻', '👓', '📚', '🥇', '❤️', '🤟', '🔥', '🏗', '🧹', '💻', '🧘🏽', '🚀', '😎'];
      return emojis[Number(categoryType)];
    },
  },
};
